import { METER_STR, SIC, STRATIFY, THIRTY_CM_STR } from 'constants/projects';

import {
  MeterCoreFormType,
  RegistryConfig,
  SamplePlanFormV2Type,
  SoilHealthFormType,
  ThirtyCmCoreFormType,
  WetAggregateStabilityFormType,
} from 'store/projects/types';

export const getSamplePlanFormValues = (config: RegistryConfig): Partial<SamplePlanFormV2Type> => ({
  project_type: config.land_types[0],
  exclusion_layers: config?.exclusion_layers,
  method: STRATIFY,
  isMeterCore: config.depths.includes(METER_STR),
  isThirtyCmCore: config.depths.includes(THIRTY_CM_STR),
  isSoilHealth: true,
  isWetAggregateStability: true,
  tree_shrub: 85,
  slope: 58,
});

export const getMeterCoreFormValues = (
  config: RegistryConfig['meter_core'] | undefined,
): MeterCoreFormType => ({
  lab: config?.labs?.[0] || '',
  sic: config?.sic.default ? SIC : '',
  density: config?.densities?.[0] || 0,
  texture_density: config?.texture_densities?.[0] || '',
  is_split_core: config?.is_split_core.default || false,
  splits: config?.splits?.length ? String(config?.splits?.[0]?.value) : '',
  frozen_storage: config?.frozen_storage.default || false,
  field_requirement: config?.min_one_per_field.default || false,
  add_texture_ph: config?.add_texture_and_ph.default || false,
});

export const getThirtyCmCoreFormValues = (
  config: RegistryConfig['thirty_cm_core'] | undefined,
): ThirtyCmCoreFormType => ({
  lab: config?.labs?.[0] || '',
  sic: config?.sic.default ? SIC : '',
  density: config?.densities?.[0] || 0,
  texture_density: config?.texture_densities?.[0] || '',
  is_split_core: config?.is_split_core.default || false,
  field_requirement: config?.min_one_per_field.default || false,
  add_texture_ph: config?.add_texture_and_ph.default || false,
});

export const getSoilHealthFormValues = (
  config: RegistryConfig['soil_health'] | undefined,
): SoilHealthFormType => ({
  lab: config?.labs?.[0] || '',
  density: config?.densities?.[0] || '',
});

export const getWetAggregateStabilityFormValues = (
  config: RegistryConfig['wet_aggregate_stability'] | undefined,
): WetAggregateStabilityFormType => ({
  lab: config?.labs?.[0] || '',
  density: config?.densities?.[0] || '',
});

export const getDensityOptionsFromConfig = (densities: number[]) => {
  return densities.map((value) => ({
    value: String(value),
    label: `1 per ${value} acres`,
  }));
};
